import { render, staticRenderFns } from "./SuspensionDetails.vue?vue&type=template&id=ef251a90&scoped=true"
import script from "./SuspensionDetails.vue?vue&type=script&lang=ts"
export * from "./SuspensionDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef251a90",
  null
  
)

export default component.exports